import { render } from "./InternalProductGroupProductsPage.vue?vue&type=template&id=40b7355c&scoped=true"
import script from "./InternalProductGroupProductsPage.vue?vue&type=script&lang=js"
export * from "./InternalProductGroupProductsPage.vue?vue&type=script&lang=js"

import "./InternalProductGroupProductsPage.vue?vue&type=style&index=0&id=40b7355c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b7355c"]])

export default __exports__